import React from 'react';
import { Container, Row, Col, Card, Image } from 'react-bootstrap';

const testimonies = [
    {
        id: 1,
        name: 'Alice Johnson',
        role: 'Customer',
        image: 'https://static.blog.bolt.eu/LIVE/wp-content/uploads/2021/02/30143142/1200x628_parking_header_africa-1024x536.jpg',
        text: 'Kamsiparts Automotive Limited has been my go-to destination for high-quality auto parts. The service is exceptional, and I always receive my orders on time. Highly recommended!',
      },
      {
        id: 2,
        name: 'Bob Smith',
        role: 'Car Enthusiast',
        image: 'https://img.lovepik.com/free-png/20210928/lovepik-man-auto-repair-specialist-repairs-car-png-image_401644088_wh1200.png',
        text: 'Ive been a customer of Kamsiparts for years, and their commitment to quality is unmatched. The wide range of auto parts and accessories ensures I find exactly what I need for my vehicle.',
      },
      {
        id: 3,
        name: 'Charlie Brown',
        role: 'Mechanic',
        image: 'https://static.vecteezy.com/system/resources/previews/024/320/113/original/mechanic-man-logo-handyman-for-service-repairman-or-maintenance-mascot-concept-cartoon-character-design-isolated-illustration-png.png',
        text: 'As a mechanic, I rely on Kamsiparts for top-notch automotive components. The extensive inventory and reliable delivery make my job easier. Kamsiparts is a trusted partner in the automotive industry.',
      },
      {
        id: 4,
        name: 'Diana Miller',
        role: 'Fleet Manager',
        image: 'https://cdn-5ef4caf3c1ac18150827b7b4.closte.com/wp-content/uploads/2023/07/relaxed-fleet-manager.png',
        text: 'Managing a fleet demands efficiency, and Kamsiparts Automotive Limited delivers just that. Their bulk purchase options and swift deliveries ensure our fleet stays on the road without any interruptions. Great service!',
      },
    ];
    

function TestimonySection() {
  return (
    <Container fluid className="bg-light py-5">
        <hr/>
      <Container>
        <h2 className="text-center mb-4">Customer Testimonials</h2>
        <Row className="justify-content-center">
        <hr className="m-4" />
          {testimonies.map((testimonial) => (
            <Col key={testimonial.id} xs={10} md={6} lg={3} className="mb-4">
              <Card className="shadow">
                <Card.Body className="text-center">
                  <Image className="mb-3 mx-auto d-block" style={{width:'50%',objectFit:'cover', height:'120px'}} src={testimonial.image} alt={testimonial.name} roundedCircle  />
                  <Card.Title className="text-center">{testimonial.name}</Card.Title>
                  <Card.Subtitle className="text-center mb-3">{testimonial.role}</Card.Subtitle>
                  <Card.Text>{testimonial.text}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
      <hr className="m-4" />
    </Container>
    
  );
}

export default TestimonySection;
